module.exports = __webpack_public_path__ + "img/CompetencyOverviewFocused.a5000cdb.jpg";